
export type SearchAllMessagesParams = {
q: string;
page?: number;
size?: number;
};
